// src/hooks/useTokenParams.ts
import { useLocation } from 'react-router-dom';
import { detokenizeQueryString } from '../common/utilities/encodeURIComponent';

interface TokenParams {
  boatId: number | null;
  tripId: number | null;
  diver: number;
  currentYear: number;
  searchType: number;
  monthId: number;
  destination: string;
  month: string;
  destinationId: number;
  isTokenEmpty: boolean;
}

const useTokenParams = (): TokenParams => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const tokenParams = params.get('token') || '';
  const token = detokenizeQueryString(tokenParams);
  const isTokenEmpty =
    !tokenParams || !token || Object.keys(token).length === 0;

  const parseNumber = (value: unknown, defaultValue: number): number =>
    isNaN(Number(value)) ? defaultValue : Number(value);

  const parseNumberOrNull = (value: unknown): number | null =>
    value == null || isNaN(Number(value)) ? null : Number(value);

  return {
    boatId: parseNumberOrNull(token?.boatId),
    tripId: parseNumberOrNull(token?.tripId),
    diver: parseNumber(token?.diver, 1),
    currentYear: parseNumber(token?.currentYear, new Date().getFullYear()),
    searchType: parseNumber(token?.searchType, 0),
    monthId: parseNumber(token?.monthId, 0),
    destination: token?.destination?.toString() || 'Anywhere',
    month: token?.month?.toString() || 'Anytime',
    destinationId: parseNumber(token?.destinationId, 0),
    isTokenEmpty,
  };
};

export default useTokenParams;
